import { CAMPAIGN_INSTRUCTION_TYPE } from 'modules/campaigns/config';

export const isDisplayCampaign = campaign => {
    const { campaignItemType } = campaign || {};
    return (
        campaignItemType === CAMPAIGN_INSTRUCTION_TYPE.HAS_DISPLAY_ITEMS ||
        campaignItemType === CAMPAIGN_INSTRUCTION_TYPE.HAS_NO_ITEMS_DISPLAY
    );
};
